import { render } from "./vehicleView.vue?vue&type=template&id=042284e2&scoped=true"
import script from "./vehicleView.vue?vue&type=script&lang=js"
export * from "./vehicleView.vue?vue&type=script&lang=js"

import "./vehicleView.vue?vue&type=style&index=0&id=042284e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042284e2"]])

export default __exports__